import React from "react";
import { Box, Flex, Grid, Icon, Skeleton, Text, } from "@chakra-ui/react";
import BeneficiaryAssestmentTable from "./BeneficiaryAssessmentTable";
import { useBeneficiary } from "hooks/beneficiary";

const BeneficiaryFirstAssessment = () => {
    const { beneficiary: { firstReception }, loading } = useBeneficiary();
    const firstAssessment = firstReception;

    if (loading) return "carregando";
    return (
        <Flex width="100%" height="100%" direction="column">
            <Grid
                templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
                templateRows={{ sm: "repeat(1, 1fr)", md: "repeat(1, 1fr)" }}
                gap="20px"
                width="100%"
            >
                {
                    loading ?
                        <Box width="100%">
                            <Flex width="100%" fontSize="15px">
                                <Icon icon="note" margin="25" size="xl" />
                                <Grid
                                    templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
                                    templateRows={{ sm: "repeat(1, 1fr)", md: "repeat(1, 1fr)" }}
                                    gap="6px"
                                    fontSize="20px"
                                    width="100%"
                                >
                                    <Skeleton isLoaded={!loading} height="27px" />
                                    <Skeleton isLoaded={!loading} height="30px" />
                                </Grid>
                            </Flex>
                        </Box>
                        :
                        !firstAssessment ?
                            <Text fontSize="lg" fontWeight="bold">
                                Formulário ainda não foi respondido
                            </Text>
                            :
                            <BeneficiaryAssestmentTable assessment={firstAssessment} />
                }
            </Grid>
        </Flex>
    )
}

export default BeneficiaryFirstAssessment
